<template>
	<div>
		<div class="contentMenu">
			<div class="marginl10 padding-10">
				<img src="./images/back.png" alt="" class="zh-back">
				<span class="back-page" @click="back()">返回上一页</span>
			</div>
			<h4 class="marginl10">转交救援公司获取报价</h4>
			<h5 class="marginl10">A、案件基本信息<span class="padding-20">案件编号：AJJ293223</span></h5>
			<div>
				<div class="case_box">
					<ul>
						<li v-for="(v,ind) in inf" :key="ind">
							<span v-if="v.flag" class="btn_box">{{v.data}}</span>
							<span v-else>{{v}}</span>
						</li>
					</ul>
				</div>
				<h5 class="marginl10">B、出险信息</h5>
				<parinf :dataArr='objdata'></parinf>
			</div>
			<h5 class="marginl10">D、保险公司授权说明及文件</h5>
			<div class="fjdiv" style="margin: 10px 50px;">
				<p>说明：无</p>
				<div class="exp_box">
					<attaList :attaArr=acc_list></attaList>
				</div>

			</div>
			<h5 class="marginl10">C、服务清单</h5>
			<div class="rescue_box" v-for="(item,ind) in checkList" :key="ind">
				<p>{{item.name}}</p>
				<div class="menzhenjiuyi">
					<ul>
						<li v-for="(item,index) in item.list">
							<div class="list">
								<img src="./../../assets/img/checked.png">
								<p>{{item.dict.name}}</p>
								<p class="text1" v-show="item.obj.fee==-1">无限额</p>
								<p class="text1" v-show="item.obj.fee>0">限额:{{item.obj.fee}}</p>
							</div>
							<p class="text2">说明：{{setTxt(item.obj.description,'zh') || '无'}}</p>
							<!-- <textarea placeholder="添加回复"></textarea> -->
							<changeLanguage style='margin-top: 10px;margin-left: 35px;' class="marginl10" ></changeLanguage>
						</li>
					</ul>
				</div>
			</div>
			<h5 class="marginl10">E、相关救援说明(指挥中心添加)</h5>
			<div>
				<!-- <el-input v-model="stateText4" style="margin: 10px 60px;width: 90%;" type="textarea" placeholder="请抓紧报价，非常感谢，附件是说明文件"></el-input> -->
				<changeLanguage style='margin-top: 10px;margin-left: 35px;' class="marginl10" v-model='stateText4'></changeLanguage>
			</div>

			<div class="fjdiv" style="margin-left: 6%;">
				<div @click="imgVisible=true" style="color: #00abfa;">
					<img src="../../../static/images/fj.png" alt="" class="fjimg" > 上传附件
				</div>
				<attaList :attaArr=up_acc.slice(1,up_acc.length)></attaList>
			</div>

			<div style="text-align: center;margin-top:20px;padding-bottom:20px;">
				<el-button type="primary" style="width: 200px;" @click="centerDialogVisible = true">确认转发救援公司</el-button>
			</div>
		</div>

		<el-dialog title="获取报价" :visible.sync="centerDialogVisible" width="30%" center>
			<p style="text-align: center;"><span>您正在向救援机构获取报价，确认转发</span></p>
			<span slot="footer" class="dialog-footer">
	    <el-button @click="centerDialogVisible = false" size="medium" style="width:170px;">取 消</el-button>
	    <el-button type="primary" @click="centerDialogVisible = false;tooffer()" size="medium" style="width:170px;">确 定</el-button>
	  </span>
		</el-dialog>
		<el-dialog title="上传方案" :visible.sync="imgVisible" class="img_dialog" width="50%" center>
			<p><span>附件名称</span>
				<el-input type="text" placeholder="上传方案及报价" v-model="txts"></el-input>
			</p>
			<p>
				<span>附件地址 </span>
				<input type="file" name="file" id="filebox" @change="handleGetFile($event)">
			</p>
			<p class="p">
				<el-button center type="button" size="small" @click="uploadFile(),imgVisible=false">确定</el-button>
			</p>
		</el-dialog>
	</div>
</template>

<script>
	import qs from "qs";
	import { Message } from "element-ui";
	import err from "@/util/error2msg.js";
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import fuwuqingdan from "@/components/attachment/qingdan";
	import attaList from "@/components/attachment/index1";
	import { getNodeDataRegulator,uploadCnts,getCasedetail } from '@/views/axios/api.js';
	import changeLanguage from '@/components/common/changeLange.vue'
	import parinf from '@/components/par/Parinf.vue'
	export default {
		data() {
			return {
				imgVisible: false,
				def: "",
				txts: "",
				token:JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				obj: '',
				victimList: '',
				checkList: [],
				data: null,
				inf: null,
				stateText4: '',
				objdata: [],
				acc_list: [],
				up_acc: [{
					icon: "../../../static/images/eles_no.png",
					description: "",
					url: ''
				}],
				options: [],
				value: "",
				url: '',
				centerDialogVisible: false,
				typeId: this.$route.query.typeId
			};
		},
		components:{
			fuwuqingdan,
			attaList,
			changeLanguage,
			parinf
		},
		mounted: function() {
      if(this.$route.params.obj){
        this.obj=this.$route.params.obj[this.$route.params.index]
      }
      if(this.$route.params.victimList){
        this.victimList=this.$route.params.victimList[this.$route.params.index]
      }
			window.scrollTo(0,0);
			let that = this;
			that.setdata();
			this.getFwqd()
			this.loadauxfiles();
		},
		methods: {
			setTxt(str,status){
				return constants.setTxt(str,status,true)
			},
			getFwqd(){
				var data={
					token:this.token,
					caseId:this.caseid
				}
				getNodeDataRegulator(data)
				.then(res => {
					console.log(res)
					var data=res.data
					this.data = data;
					data.obj2.map(v => {
						if(v.dict.parentId == "0") {
							var obj = {};
							obj.id = v.dict.parentId;
							obj.childId = v.dict.id;
							obj.name = v.dict.name;
							obj.list = [];
							this.checkList.push(obj);
						} else {
							this.checkList.map(o => {
								if(v.dict.parentId == o.childId) {
									//console.log(v.dict.parentId)
									o.list.push(v);
								}
							});
						}
					});
				})
				.catch( err => {
					console.log(err)
				})
			},
			back() {
				let that = this;
				this.$router.push({
					name: "ComOffer",
					params: {
						token: that.token
					},
					query: {
						typeId: that.typeId
					}
				});
			},
			loadauxfiles() {
					var data={
						token:this.token,
						objId:this.caseid,
						caseId:this.caseid,
						objType:1
					}
					uploadCnts(data)
					.then(res => {
						res.data.obj.map(v => {
							if(constants.isPic(v.url)) {
								v.icon = v.url;
							} else {
								v.icon = "../../../static/images/eles_icon.png";
							}
							this.acc_list.push(v);
						});
					})
					.catch(err => {
						console.log(err)
					})
			},
			setdata() {
				let addr = "";
					var data={
						token:this.token,
						caseId:this.caseid
					}
					getCasedetail(data)
					.then(res => {
						this.init = res.data.obj;
						this.obj = res.data.obj;
						this.victimList = res.data.obj.victimList;
						if(this.init.generalLocation) {
							addr = this.init.generalLocation.addr;
						}
						this.objdata = {
							add: "出险地:" +
								(this.init.caseCountry || "") +
								(this.init.caseCity || "") +
								addr,
							type: "事故类型：" + (this.init.obj.accidentType || ""),
							part: "受伤部位：" + (this.victimList[0].obj.injuredPart || ""),
							weather: "天气灾害：" + (this.init.obj.weatherTag || "无")
						};
						this.def = this.init.obj.incidentDesc;
						this.inf = {
							time: "报案时间" + constants.time(this.init.obj.reportTs),
							user: "报案人：" + (this.init.obj.reportUser || ""),
							sex: "性别：男",
							phone: "报案电话：" + (this.init.obj.reporterContact || ""),
							instime: "出险时间：" + constants.time(this.init.obj.incidentTs),
							null: "-",
							card: "证件号码：" + (this.victimList[0].obj.idNo || ""),
							number: "保单号码：" + (this.victimList[0].obj.insurancePolicyNo || ""),
							pardata: {
								flag: true,
								data: "保单详情"
							},
							belong: "所属保险公司：" + (this.victimList[0].insuranceCompany || ""),
							source: "案件信息来源：" + (this.obj.caseSrc || ""),
							exp: "来源说明：" + (this.obj.caseSrcDesc || "")
						};
					})
					.catch(err => {
						console.log(err)
					})
			},
			error2msg(errcode) {
				var errmsg = err;
				var msg = errmsg.tomsg(errcode);
				Message.error(msg);
			},
			tooffer() {
				let that = this;
				let tUploadCnts = this.up_acc.slice();
				tUploadCnts.shift();
				this.axios
					.post(
						constants.domain + "rescue/bidding/submit_bidding",
						qs.stringify({
							token: this.token,
							caseId: this.caseid,
							upaccStr: JSON.stringify(tUploadCnts),
							stateText4: this.stateText4,
						})
					)
					.then(res => {
						console.log(res);
						if(res.data.code == 0) {
							Message({
								message: "操作成功",
								type: "success"
							});
							that.$router.push({
								name: 'ComOffer',
								params: {
									token: that.token
								},
								query: {
									typeId: that.typeId
								}

							})
						} else {
							this.error2msg(res.data.code);
						}
					});
			},
			handleGetFile(e) {
				this.file = e.target.files[0];
				this.txts = this.file.name;
			},
			uploadFile() {
				let that = this;
				var reader = new FileReader();
				reader.readAsDataURL(this.file);
				let formdata = new FormData();
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				formdata.append(
					"token",
					this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data
				);
				reader.onload = function(e) {
					that.avatar = this.result;
					formdata.append("file", that.file);
					that.axios
						.post(
							constants.domain + "rescue/case/upload_file",
							formdata,
							config
						)
						.then(res => {
							that.url = res.data.obj;
							that.up();
						});
				};
			},
			up() {
				console.log(this.url)
				let flag = constants.isPic(this.url);
				if(flag) {
					this.up_acc.push({
						flag: true,
						url: this.url,
						description: this.txts,
						icon: this.url,
					});
				} else {
					if(this.url === "") {
						Message.error("请上传附件");
					} else {
						this.up_acc.push({
							flag: false,
							url: this.url,
							description: this.txts,
							icon: "../../../static/images/eles_icon.png"
						});
					}
				}
			},
			onSubmit() {
				console.log("submit!");
			}
		}
	};
</script>

<style scoped>
	@import url("./style.css");
	.case_box {
		width: 100%;
	}

	.case_box p {
		line-height: 45px;
	}

	.case_box p span {
		margin-left: 20px;
	}

	.case_box ul {
		border: 1px solid #d9ddde;
	}

	.case_box ul li {
		width: 39%;
		text-align: start;
		text-indent: 1em;
		font-size: 14px;
		overflow: hidden;
		height: 42px;
		display: inline-block;
		line-height: 42px;
		border-right: #d9ddde 1px solid;
		border-top: #d9ddde 1px solid;
	}

	.case_box ul li:nth-child(3n) {
		border-right: 0;
		width: 20%;
	}

	.case_box ul li:first-child,
	.case_box ul li:nth-child(2),
	.case_box ul li:nth-child(3) {
		border-top: 0;
	}

	.el-input-group {
		width: 29%;
	}

	.selecti {
		text-align: right;
		margin-right: 5px;
	}

	.newTab td {
		padding: 10px 0px 10px 40px;
	}

	.rescue_box {
		box-sizing: border-box;
		padding: 0 50px;
	}

	.rescue_box>p {
		line-height: 40px;
		font-size: 14px;
	}

	.rescue_box .el-checkbox-group {
		padding-left: 28px;
	}

	.el-checkbox__inner {
		margin-bottom: 60px;
	}

	.img_dialog p {
		width: 100%;
		line-height: 48px;
	}

	.img_dialog p .el-input {
		width: 80%;
		margin-left: 3%;
	}

	.img_dialog p span {
		color: #333;
	}

	.img_dialog p input[type="file"] {
		margin-left: 3%;
	}

	.p {
		text-align: center;
	}

	.data_wrap {
		width: 100%;
		box-sizing: border-box;
		padding: 0 40px;
	}

	.data_wrap ul {
		width: 100%;
		overflow: hidden;
	}

	.data_wrap ul li {
		float: left;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		margin-right: 20px;
	}

	.data_wrap ul li:last-child textarea {
		width: 80%;
		height: 80px;
		border: 0;
		border: 1px solid #d9ddde;
		border-radius: 5px;
		font-size: 15px;
		margin-top: 15px
	}

	.data_wrap ul li:last-child span,
	.data_wrap ul li:last-child textarea {
		float: left;
  }
	.ddcx {
		box-sizing: border-box;
		padding: 10px 10px;
	}

	.ddcx>p {
		color: #333;
		line-height: 40px;
		font-size: 15px;
	}

	.ddcx ul li {
		display: inline-block;
		width: 20%;
		text-align: center;
	}

	.ddcx ul li p {
		text-align: center;
		line-height: 36px;
		font-size: 14px;
	}

	.ddcx ul li img {
		width: 90px;
		height: 120px;
	}

	.ddcx ul li a {
		color: #00abfa;
		font-size: 14px;
	}

	.acc_box {
		box-sizing: border-box;
		padding: 10px 10px;
	}

	.acc_box>p {
		color: #333;
		line-height: 40px;
		font-size: 15px;
	}

	.acc_box ul li {
		display: inline-block;
		width: 20%;
		text-align: center;
	}

	.acc_box ul li p {
		text-align: center;
		line-height: 36px;
		height: 36px;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.acc_box ul li img {
		width: 90px;
		height: 120px;
	}

	.acc_box ul li a {
		color: #00abfa;
		font-size: 14px;
	}
	h5.marginl10{margin-bottom: 10px;}
	.menzhenjiuyi{margin-top: 10px;margin-left: 46px;}
	.menzhenjiuyi li{margin-bottom: 30px;}
	.menzhenjiuyi .list{overflow: hidden;margin-bottom: 5px;}
	.menzhenjiuyi .list *{float: left;margin-right: 10px;}
	.menzhenjiuyi .list img {height: 18px;margin-top: 3px;cursor: not-allowed;}
	.menzhenjiuyi textarea {display: block;width: 60%;margin-top: 10px;padding: 10px;height: 50px;border-radius: 5px;border: 1px solid #d9ddde;outline: none;margin-left: 33px;}
	.menzhenjiuyi .text1{color: #df1717;}
	.menzhenjiuyi .text2{margin-left: 33px;color: #999;}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/helpCompany.vue